import React from 'react'
import { Grid, Card } from '@scuf/common'
import { useNavigate } from 'react-router-dom'
import LanguageStrings from '../../../i18n/locales'
import { getOperationPermissions } from '../redux/actionCreator'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { useAuth } from 'react-oidc-context'
import { type OperationPermissionState } from '../redux/operationPermissionSlice'
import { type RootState } from '../../../store'
import './Dashboard.css'

const Dashboard = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const DashboardStrings = LanguageStrings().ThermalIQStrings.ThermalIQDashboard
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const auth = useAuth()

  React.useEffect(() => {
    // istanbul ignore next
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
  }, [])

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={12}>
          <h1 style={{ fontWeight: 700, fontSize: '22px', marginTop: '0.5em' }}>
            {/* {DashboardStrings.Configuration} */}
          </h1>
        </Grid.Column>
        <Grid.Row className="thermal-card-page">
          {/* <Grid.Column width={3} mWidth={6} sWidth={12}>
            <Card data-testid='device-dashboard' className="thermal-card dashboard" onClick={() => { navigate('/device-dashboard') }}>
              <Card.Content className='admin-card-titles'>{DashboardStrings.Dashboard}</Card.Content>
            </Card>
          </Grid.Column> */}
          <Grid.Column width={3} mWidth={6} sWidth={12}>
            <Card data-testid='site-configuration' className="thermal-card site-configuration" onClick={() => { navigate('/site-list') }}>
              <Card.Content className='admin-card-titles'>{DashboardStrings.SiteConfiguration}</Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={3} mWidth={6} sWidth={12}>
            <Card data-testid='custom-KPI' className="thermal-card custom-performance-indicators" onClick={() => { navigate('/custom-kpi-list') }}>
              <Card.Content className='admin-card-titles'>{DashboardStrings.Custom_Performance_Indicators}</Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={3} mWidth={6} sWidth={12}>
             <Card data-testid='services' className="thermal-card services" onClick={() => { navigate('/email-service-list') }}>
              <Card.Content className='admin-card-titles'>{'SERVICES'}</Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={3} mWidth={6} sWidth={12}>
             <Card data-testid='custom-device' className="thermal-card custom-template" onClick={() => { navigate('/custom-device-template-list') }}>
              <Card.Content className='admin-card-titles'>{'CUSTOM DEVICE TEMPLATE'}</Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid.Row>
    </Grid>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
}
const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub))
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
export default connector(Dashboard)
